/** Chave de localStorage do session_id anônimo do cliente mobile (escopado por tela). */
export function jukeboxSessionKey(telaId: string): string {
  return `ds:jukebox_session:${telaId}`;
}

/** UUID v4 persistido por tela — usado em pedidos Jukebox, votos pré-jogo e Bolão. */
export function obterOuCriarSessionId(telaId: string): string {
  const key = jukeboxSessionKey(telaId);
  const existente = localStorage.getItem(key);
  if (existente) return existente;
  const novo = crypto.randomUUID();
  localStorage.setItem(key, novo);
  return novo;
}

/** Descarta o session_id da tela (usado quando o servidor diz que ele pertence a outro cliente). */
export function descartarSessionId(telaId: string): void {
  localStorage.removeItem(jukeboxSessionKey(telaId));
}
